/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Legs3(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Legs3.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Legs3.geometry}
        position={[-1.38, 0, -2.72]}
      >
        <meshPhysicalMaterial
          color={colorArr[5]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('models/Legs3.glb')
